import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const HeaderImage = () => (
  <StaticQuery
    query={graphql`
      query {
        file(relativePath: { regex: "/home_header_no_shadow_cropped.png/" }) {
          childImageSharp {
            fluid(maxWidth: 1400, quality: 100) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `}
    render={data => (
      <Img
        className="gatsby-rounded gatsby-box-shadow"
        alt="A screenshot of the CineSend application"
        fluid={data.file.childImageSharp.fluid}
      />
    )}
  />
)

export default HeaderImage
